import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import Table from "../../../components/Admin/Table";
import { Toast } from "primereact/toast";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import "./TimesheetSummary.css";
import { appInsights } from "../../../AppInsights";
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import Spinner from "../../../components/Spinner/spinner";
import {
  getAllEmployeeList,
  getTimesheetSummary,
  getTimesheetSummaryExcelFile,
  sendEmailNotification,
} from "../../../services/viewTimeSheet";
const TimesheetSummary = () => {
  const [progressBar, setCopyProgressBar] = useState(false);
  const { userData } = useSelector((state) => state?.user);
  const [selectedMonth, setSelectedMonth] = useState(new Date()?.getMonth());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedProjectType, setSelectedProjectType] = useState("all");
  const [selectedEmployee, setSelectedEmployee] = useState("all");
  const [employeeFilter, setEmployeeFilter] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [filteredData, setFilteredData] = useState();
  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [timesheets, setTimesheets] = useState([]);
  const toast = React.useRef(null);
  const currentUserTypeId = localStorage.getItem("userTypeId");
    const currentUserRoleId = userData?.userTypes?.find(
    (type) => type?.userTypeId == currentUserTypeId
  );
  const months = [
    { label: "All Months", value: "all" },
    { label: "January", value: 1 },
    { label: "February", value: 2 },
    { label: "March", value: 3 },
    { label: "April", value: 4 },
    { label: "May", value: 5 },
    { label: "June", value: 6 },
    { label: "July", value: 7 },
    { label: "August", value: 8 },
    { label: "September", value: 9 },
    { label: "October", value: 10 },
    { label: "November", value: 11 },
    { label: "December", value: 12 },
  ];
 let year = [
        { label: 'All Years', value: null },
        { label: '2024', value: 2024 },
        { label: '2025', value: 2025 },
    ];
    const currentYear = new Date().getFullYear();
    if (!year.some(y => y.value === currentYear)) {
        year.push({ label: currentYear.toString(), value: currentYear });
    }
  const projectTypes = [
    { label: "All Project Types", value: "all" },
    { label: "External Projects", value: "external" },
    { label: "Internal Projects", value: "internal" },
  ];
  const statusOptions = [
    { label: "All Status", value: "all" },
    { label: "Submitted", value: 1 },
    { label: "Not Submitted", value: 2 },
  ];
  useEffect(() => {
    const projectTypeId =
      selectedProjectType === "all"
        ? null
        : selectedProjectType === "internal"
        ? 1
        : 2;
    fetchTimesheetSummary(
      selectedYear,
      selectedMonth,
      projectTypeId,
      selectedEmployee,
      selectedStatus
    );
  }, [
    selectedYear,
    selectedMonth,
    selectedProjectType,
    selectedEmployee,
    selectedStatus,
  ]);
  const fetchEmployees = async () => {
    try {
      const response = await getAllEmployeeList();
      const employeeOptions = [
        { label: "All Employees", value: "all" },
        ...response?.map((emp) => ({
          label: emp?.userName
            ?.split(" ")
            .map(
              (word) =>
                word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase()
            )
            .join(" "),
          value: emp?.userId,
        })),
      ];
      setEmployees(employeeOptions);
    } catch (error) {
      appInsights.trackException("Get TimeSheet Summary", { exception: error });
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.message || "Something went wrong at Server Side",
      });
    }
  };

  const handleApproveEmailTrigger = async (data) => {
    setCopyProgressBar(true);
    try {
      if (typeof data?.year !== "number" || typeof data?.month !== "number") {
        //  TODO: add toast
        toast?.current?.show({
          severity: "error",
          summary: "Error",
          detail: `Please select a year and month before sending mail.`,
          life: 3000,
        });
        return;
      }
      let result = await sendEmailNotification(
        data?.year,
        data?.month,
        currentUserTypeId,
        [data?.id]
      );
      if (result) {
        toast?.current?.show({
          severity: "success",
          summary: "Successful",
          detail: `${result}`,
          life: 3000,
        });
      }
    } catch (error) {
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.message
          ? error?.message
          : error?.status === 400
          ? "User not Found"
          : error?.status === 500
          ? "Internal Server Error"
          : error?.status === 404
          ? "User not Found"
          : "Error occurred while submitting details",
        life: 5000,
      });

      appInsights.trackException(
        "Time Summary screen: Email trigger function failure",
        { exception: error }
      );
    }
    setCopyProgressBar(false);
  };
  const handleEmailTrigger = (data) => {
    try {
      confirmDialog({
        message: "Are you sure you want to send mail notification",
        header: "Confirm Approval",
        icon: "pi pi-check-circle",
        acceptClassName: "p-button-success",
        accept: () => handleApproveEmailTrigger(data),
        reject: () => {},
      });
    } catch (error) {}
  };

  const renderHeader = () => {
    return (
      <div className="grid">
        <div className="col-12 md:col-3">
          <Dropdown
            value={selectedYear}
            options={year}
            onChange={(e) => setSelectedYear(e?.value)}
            className="w-full"
          />
        </div>
        <div className="col-12 md:col-3">
          <Dropdown
            value={selectedMonth}
            options={months}
            onChange={(e) => setSelectedMonth(e?.value)}
            placeholder="Month"
            className="w-full"
          />
        </div>
        <div className="col-12 md:col-3">
          <Dropdown
            value={selectedProjectType}
            options={projectTypes}
            onChange={(e) => setSelectedProjectType(e?.value)}
            placeholder="Project Type"
            className="w-full"
          />
        </div>
        <div className="col-12 md:col-3">
          <span className="p-input-icon-left w-full d-flex align-items-center">
            <div>
              <i className="pi pi-search" />
            </div>
            <Dropdown
              value={selectedEmployee}
              options={employees?.filter(
                (emp) =>
                  emp?.value === "all" ||
                  emp?.label
                    ?.toLowerCase()
                    .includes(employeeFilter?.toLowerCase())
              )}
              onChange={(e) => setSelectedEmployee(e?.value)}
              placeholder="Employee"
              className="w-full"
              filter
              filterValue={employeeFilter}
              onFilter={(e) => setEmployeeFilter(e.filter)}
              showClear
            />
          </span>
        </div>
        <div className="col-12">
          <div className="grid justify-content-end">
            <div className="col-12 md:col-3">
              <Dropdown
                value={selectedStatus}
                options={statusOptions}
                onChange={(e) => setSelectedStatus(e?.value)}
                placeholder="Select Status"
                className="w-full status-filter"
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  const actions = {
    email: {
      label: "Notify via mail",
      enabled: true,
      onClick: handleEmailTrigger,
    },
  };
  const fetchTimesheetSummary = async (
    year,
    month,
    projectTypeId,
    userId,
    statusId
  ) => {
    try {
      //api call
      let result = await getTimesheetSummary(
        year,
        month,
        projectTypeId,
        userId,
        statusId
      );
      //result
      let formattedTimesheets = result?.map((ts) => ({
        name: ts?.userName
          ?.split(" ")
          .map(
            (word) =>
              word?.charAt(0)?.toUpperCase() + word?.slice(1).toLowerCase()
          )
          .join(" "),
        status: ts?.status?.toLowerCase(),
        email: ts?.email,
        id: ts?.userId,
        projectType: ts?.projectType,
        year: selectedYear,
        month: selectedMonth,
        userTypeId: ts?.projectTypeId,
      }));
      setTimesheets(formattedTimesheets);
    } catch (error) {
      appInsights.trackException("Get TimeSheet Summary", { exception: error });
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.message || "Something went wrong at Server Side",
      });
    } finally {
      setLoading(false);
    }
  };
    const downloadBtn = () => {
      const projectTypeId =
        selectedProjectType === "all"
          ? null
          : selectedProjectType === "internal"
          ? 1
          : 2;
      const paginatorRight = (
        <div className="">
          <Button
            type="button"
            icon="pi pi-download"
            label="Download"
            className="p-button-outlined border-1 border-round surface-border"
            onClick={() => {
             downloadExcelForTimesheetSummary(selectedYear,selectedMonth,currentUserRoleId?.userTypeId,1,projectTypeId,selectedEmployee,selectedStatus);
            }}
          />
        </div>
      );
      return paginatorRight;
    };
  
  const downloadExcelForTimesheetSummary = async (
    year,
    month,
    loggedInUserTypeId,
    userTypeId,
    projectType,
    employeeId,
    statusId
  ) => {
    try {
      if (typeof year !== "number" || typeof month !== "number") {
        //  TODO: add toast
        toast?.current?.show({
          severity: "error",
          summary: "Error",
          detail: `Please select a year and month before downloading`,
          life: 3000,
        });
        return;
      }
      const monthName = months?.filter((x) => x?.value == month);
      const { url, filename } = await getTimesheetSummaryExcelFile(
        year,
        month,
        loggedInUserTypeId,
        userTypeId,
        projectType,
        employeeId,
        statusId,
        monthName[0]?.label
      );

      // Create a temporary <a> element to trigger the download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename); // Set the filename from the response header
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Clean up the Blob URL after the download
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (error) {
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail:
          error?.message || error?.status == 400
            ? "Timesheet Summary entries not found for the given month or year"
            : error?.status == 500
            ? "Internal Server Error"
            : "Error while fetching details",
        life: 3000,
      });
    }
  };

  useEffect(() => {
    fetchEmployees();
  }, []);
  useEffect(() => {
    if (timesheets) {
      let data = timesheets;
      let status = statusOptions.filter((x) => x?.value == selectedStatus);
      // Apply status filter
      if (selectedStatus && selectedStatus !== "all") {
        data = data?.filter(
          (ts) =>
            ts?.status?.toLowerCase()?.trim().split(" ").join("") ===
            status[0]?.label?.toLowerCase()?.trim().split(" ").join("")
        );
      }

      // Apply project type filter
      if (selectedProjectType && selectedProjectType !== "all") {
        if (selectedProjectType?.toLowerCase() === "internal") {
          data = data?.filter((ts) => ts?.userTypeId == 1);
        } else if (selectedProjectType?.toLowerCase() === "external") {
          data = data?.filter((ts) => ts?.userTypeId == 2);
        }
      }

      // Apply employee filter
      if (selectedEmployee && selectedEmployee !== "all") {
        data = data?.filter((ts) => ts?.userId === selectedEmployee?.value);
      }

      setFilteredData(data);
    }
  }, [timesheets, selectedStatus, selectedEmployee]);
  // useEffect(() => {
  //   fetchTimesheetSummary();
  // }, [selectedEmployee, selectedMonth, selectedProjectType, selectedYear]);
  const tableStyle = {
    dataTable: "p-datatable-sm",
  };
  const columns = [
    {
      field: "name",
      header: "Employee Name",
      sortable: true,
      frozen:true
    },
    {
      field: "email",
      header: "Email",
    },
    { field: "projectType", header: "Project Type" },
    // { field: "projects", header: "Projects", type: "projects1" },
    { field: "status", header: "Submission Status", type: "status" },
  ];
  return (
    <div className="timesheet-admin-container p-3 border-round-xl bg-white">
      <Toast ref={toast} />
      <ConfirmDialog className="adminRejectDialog" />
      <div className="flex justify-content-between px-1 align-items-center">
        <div className="flex align-items-center p-2 gap-2">
          <h2 className="font-bold m-0 pl-2 pr-3 timesheet_heading">
            Timesheet Summary
          </h2>
          {filteredData && (
            <span className="count-span pl-4 pr-4 p-2">
              {" "}
              {filteredData?.length}{" "}
            </span>
          )}
        </div>
        <div className="col-12 md:col-2 download-div">{downloadBtn()}</div>
      </div>
      <div className="table-container surface-section p-3 border-round-xl">
        <Table
          content={filteredData}
          columnsData={columns}
          actions={actions}
          tableStyle={tableStyle}
          header={renderHeader}
          paginator={true}
          rows={50}
          rowsPerPageOptions={[5, 10, 25, 50]}
          emptyMessage="No record found"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
          loading={loading}
          checkBox={true}
        />
      </div>
      {progressBar && <Spinner />}
    </div>
  );
};
export default TimesheetSummary;
